import Switch from '@webclient/components/switch';

import useAppDispatch from '@webclient/hooks/useAppDispatch';
import useAppSelector from '@webclient/hooks/useAppSelector';

import { setVoiceZonosTtsByUserId } from '@webclient/state/slices/app-settings';
import { selectVoice } from '@webclient/state/slices/app-settings/userSettingSelector';

/**
 * Toggle for enabling/disabling the experimental “Zonos TTS” feature.
 * Only visible for alpha users (handled by parent component).
 */
export default function ZonosTtsToggle() {
  const dispatch = useAppDispatch();
  const voice = useAppSelector(selectVoice);
  const me = useAppSelector((state) => state.auth.me);

  function handleToggle(
    _event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) {
    if (!me) return;
    dispatch(
      setVoiceZonosTtsByUserId({
        userId: me.uuid,
        zonos: checked,
      }),
    );
  }

  return <Switch checked={voice.zonos} onChange={handleToggle} />;
}
